import React, { useEffect, useState } from 'react';
import { EqualHeightElement } from 'react-equal-height';
import { useDispatch, useSelector } from 'react-redux';

// Prime-React Components
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chartjs-plugin-datalabels';

// Components
import { CustomeTooltip } from './ActionButtons';

// Utils
import { getBarOptions } from '../utils/chart';
import { isDarkMode, wordCapitalize } from '../utils/common';
import DatePicker from 'react-datepicker';

// Images
import { getScheduleInterviewCountByHR } from '../redux/actions/hr';
import { getDateWithDay } from '../utils/date';
import moment from 'moment';

const AvailableInterviewersBarChart = () => {
  const dispatch = useDispatch();
  const [hrData, setHrData] = useState([]);
  const [startDateRange, setStartDateRange] = useState(new Date());
  const [endDateRange, setEndDateRange] = useState(new Date());
  const scheduleInterviewCount = useSelector((state) => state.hrs.scheduleInterviewCount);

  function modifiedHrData(data) {
    const scheduleInterviews = data || [];
    let labels = [];
    let interviewsData = [];

    scheduleInterviews.forEach((hr) => {
      let hrName = [];
      hrName.push(hr?.FirstName ? wordCapitalize(hr?.FirstName) : '');
      hrName.push(hr?.LastName ? wordCapitalize(hr?.LastName) : '');
      labels.push(hrName);
      let candidates = new Set();
      if (hr?.RoundOfHR?.length) {
        hr?.RoundOfHR.forEach((round) => {
          candidates.add(round?.Interview?.CandidateID);
        });
      }
      interviewsData.push(candidates.size);
    });
    return { labels, interviewsData };
  }

  useEffect(() => {
    setHrData(modifiedHrData(scheduleInterviewCount));
  }, [scheduleInterviewCount]);

  const todaysInterviewerChartData = {
    labels: hrData?.labels || [],
    datasets: [
      {
        data: hrData?.interviewsData || [],
        borderWidth: 0,
        borderRadius: 50,
        barThickness: 20,
        backgroundColor: isDarkMode()
          ? [
              '#361C63',
              '#883318',
              '#096465',
              '#254555',
              '#035174',
              '#AA385F',
              '#156A0C',
              '#2A707A',
              '#6A9637'
            ]
          : [
              '#9575CD',
              '#FF8A65',
              '#64B5F6',
              '#90A4AE',
              '#4FC3F7',
              '#F06292',
              '#81C784',
              '#4DD0E1',
              '#AED581'
            ],
        datalabels: {
          color: '#FFF'
        }
      }
    ]
  };

  useEffect(() => {
    if (startDateRange && endDateRange) {
      const formattedStartDate = getDateWithDay(moment(startDateRange).startOf('day').toDate());
      const formattedEndDate = getDateWithDay(moment(endDateRange).endOf('day').toDate());

      dispatch(getScheduleInterviewCountByHR(formattedStartDate, formattedEndDate));
    }
  }, [dispatch, startDateRange, endDateRange]);

  return (
    <div className="white-box-item full-width">
      <div className="white-box">
        <div className="card-title-block card-title-inner-wrapper">
          <EqualHeightElement name="title">
            <div className="card-title-wrapper">
              <span className="card-title">Number of Candidates schedule Interview by HRs</span>
              <i
                className="custom-target-icon pi pi-info-circle pl-1"
                data-tip="Number of Candidates count of schedule interview by HRs (Cancelled interview round not counted)"
                style={{ cursor: 'pointer' }}
              />
            </div>
          </EqualHeightElement>
          <div className="filter-block">
            <CustomeTooltip />
            <div className="flex align-items-center justify-content-between datepicker-outer">
              <span className="p-float-label w-full mr-2 datepicker-wrapper">
                <DatePicker
                  id="startDate"
                  selected={startDateRange}
                  onChange={(date) => {
                    setStartDateRange(date);
                    if (moment(date).isAfter(endDateRange)) {
                      setEndDateRange(date);
                    }
                  }}
                  maxDate={new Date()}
                  onKeyDown={(e) => e.preventDefault()}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Start Date"
                  className="p-inputtext w-full custom-datepicker"
                />
                <label htmlFor="startDate">Start Date</label>
              </span>
              <span className="p-float-label w-full mr-2 datepicker-wrapper datepicker-bottom-end">
                <DatePicker
                  id="endDate"
                  selected={endDateRange}
                  onChange={(date) => setEndDateRange(date)}
                  minDate={startDateRange}
                  maxDate={new Date()}
                  onKeyDown={(e) => e.preventDefault()}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="End Date"
                  className="p-inputtext w-full custom-datepicker"
                />
                <label htmlFor="endDate">End Date</label>
              </span>
            </div>
          </div>
        </div>
        <div className="chart-container">
          <div className="chart-figure-wrapper" style={{ width: '1000px' }}>
            <Chart
              type="bar"
              data={todaysInterviewerChartData}
              options={getBarOptions()}
              plugins={[ChartDataLabels]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvailableInterviewersBarChart;
